import { render, staticRenderFns } from "./Print.vue?vue&type=template&id=4c5fe2b4&"
import script from "./Print.vue?vue&type=script&lang=ts&"
export * from "./Print.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports